export default __webpack_public_path__ + "static/media/app-error.7ce7d154.svg";